<template>
    <div>
        <div class="wrapper-campaign-header" v-if="isLoaded" @click="clickDashboard(arrDashboard[0])">
            <div class="wrapper-img">
                <img :src="arrDashboard[0].imageUrl"/>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import BzbsDashboard from "@/service/BzbsDashboard.js";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
import { DashboardConfigBuilder } from "@/service/config/DashboardConfigModel.js";

/**
 * @property {string} apiConfig (require) Dashboard config_list
 */
export default {
    name: "DashboardCard",
    components: {
    },
    props: {
        apiConfig: String
    },
    data: function() {
        return {
            arrDashboard: [],
            isLoaded: false,
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            console.log(this.apiConfig);
            var token = Account.getToken();
            var configBuilder = new DashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(token,params,this.apiConfig)
                .then(data => {
                    this.arrDashboard = data;
                    console.log(data);

                    this.isLoaded = true
                })
                .catch(error => {
                    console.log(error);
                });
        },
        clickDashboard: function(dashboard) {
            //tracking
            var user = Account.getCacheUser()
            var label = user.userId + "|" + this.apiConfig;
            Vue.ga.event(this, "promotion", "click_campaign", label);

            if (dashboard.type == "link") {
                window.open(dashboard.url, "_blank");
            } else if (dashboard.type == "campaign") {
                this.$router.push("/campaign/" + dashboard.id);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.wrapper-campaign-header {
    width: 100%;
    padding: 5px 25px 15px 25px;

    .wrapper-img {
        position: relative;
        width: 100%; /* desired width */
        img {
            @extend %content-shadow;
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 15px;
            top: 0;
            left: 0;
        }
    }

    .wrapper-img:before {
        content: "";
        display: block;
        padding-top: 56.66%; /* initial ratio of 1:1*/
    }
}
</style>
